import React, { Component } from "react" ;
import Select from 'rc-select';
import Pagination from 'rc-pagination';
import 'rc-pagination/assets/index.css';
import 'rc-select/assets/index.css';
import locale from 'rc-pagination/lib/locale/tr_TR';

class Footer extends Component{
	constructor(props){
		super(props);
		this.onShowSizeChange = this.onShowSizeChange.bind(this);
		this.onChange 		  = this.onChange.bind(this);
	}

	onShowSizeChange(current, pageSize) {
		if (isNaN(pageSize)) {
			current = 1;
			pageSize = this.props.total;
		}
		this.props.pageSize(current-1,pageSize);
	}

	onChange(current, pageSize) {
		this.props.pageSize(current-1,pageSize);
	}

	render(){
		return (
			<tfoot>
				<tr>
					<td colSpan={this.props.length}>
						<div className="row">
							<div className="col-sm-4"></div>
							<div className="col-sm-6" style={{marginTop:'20px'}}>
								<Pagination
									selectComponentClass={Select}
									showSizeChanger
									showTotal={(total) => `Kayıt Sayısı : ${total}`}
									defaultPageSize={this.props.size}
									hideOnSinglePage={!this.props.hide}
									pageSizeOptions={this.props.options}
									pageSize={this.props.size}
									onShowSizeChange={this.onShowSizeChange}
									onChange={this.onChange}
									total={this.props.total}
									className='pagi'
									locale={locale}
									showTitle={false}
									current={this.props.page+1}
									showLessItems
								/>
							</div>
							<div className="col-sm-2"></div>
						</div>
					</td>
				</tr>
			</tfoot>
		);
	}
}

export default Footer;


// WEBPACK FOOTER //
// ./src/components/Table/Footer.js